import { render, staticRenderFns } from "./BreadCrumbWordCloud.vue?vue&type=template&id=5b3a27b1&scoped=true"
import script from "./BreadCrumbWordCloud.vue?vue&type=script&lang=js"
export * from "./BreadCrumbWordCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a27b1",
  null
  
)

export default component.exports